import React, { PropTypes } from "react";
import Helmet from "react-helmet";
import SettingsForm from "./SettingsForm";
import clothingBrands from "../data/clothing-brands";
import carSeatBrands from "../data/car-seat-brands";


const Settings = ({ selectedClothingBrands, selectedCarSeatBrands, updateSelectedClothingBrands, updateSelectedCarSeatBrands, gender, changeGender }) => {
  return(
    <div>
      <Helmet title="Fit My Kid Settings" />
      <SettingsForm clothingBrands={clothingBrands}
        selectedClothingBrands={selectedClothingBrands}
        carSeatBrands={carSeatBrands}
        selectedCarSeatBrands={selectedCarSeatBrands}
        updateSelectedClothingBrands={updateSelectedClothingBrands}
        updateSelectedCarSeatBrands={updateSelectedCarSeatBrands}
        gender={gender}
        changeGender={changeGender}
      />
    </div>
  );
};

Settings.propTypes = {
  selectedClothingBrands: PropTypes.object,
  selectedCarSeatBrands: PropTypes.object,
  updateSelectedClothingBrands: PropTypes.func,
  updateSelectedCarSeatBrands: PropTypes.func,
  gender: PropTypes.string,
  changeGender: PropTypes.func,
};

export default Settings;



/** WEBPACK FOOTER **
 ** ./src/components/Settings.js
 **/